import './polyfills';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import setupAxios from './utils/axios';
import ErrorBoundary from './components/ErrorBoundary';
import SentryConfig from './components/SentryConfig';
import App from './App';
import {
  GA4_TRACKING_ID,
  OSANO_CLIENT_ID,
  OSANO_CONFIG_ID,
  COOKIE_CONSENT_VERSION,
  COOKIE_CONSENT_ENABLED,
  getReactEnv,
} from './constants';
import configureStore from './redux';
import ReactGA4 from 'react-ga4';
import 'normalize.css';
import './style/base.scss';

/**
 * These script tags are added to the head of the document to load the Osano Cookie
 * Consent platform and the IDme cookie consent script that overrides some Osano styles
 * and enables Google Consent mode in Osano.
 * These scripts must be loaded in the head of the document before any other scripts so
 * there can be an accounting of the consent before any other scripts are loaded and potentially
 * block scripts if consent is not given.
 */
if (OSANO_CLIENT_ID && OSANO_CONFIG_ID && COOKIE_CONSENT_ENABLED) {
  const osanoLocalScript = document.createElement('script');
  osanoLocalScript.src = `https://assets.id.me/cookie-consent/${COOKIE_CONSENT_VERSION}/cookie-consent.js`;

  const osanoScript = document.createElement('script');
  osanoScript.src = `https://cmp.osano.com/${OSANO_CLIENT_ID}/${OSANO_CONFIG_ID}/osano.js`;

  document.head.insertBefore(osanoScript, document.head.firstChild);
  document.head.insertBefore(osanoLocalScript, document.head.firstChild);
}

if (GA4_TRACKING_ID) {
  ReactGA4.initialize([{ trackingId: GA4_TRACKING_ID }]);
}

// TODO: remove old GA when it is not used anymore
if (getReactEnv() === 'production') {
  import('react-ga').then((ReactGA) => {
    ReactGA.initialize('UA-40672673-1');
  });
}

const store = configureStore();

setupAxios(store);

ReactDOM.render(
  <React.StrictMode>
    <ErrorBoundary>
      <Provider store={store}>
        <App />
        <SentryConfig />
      </Provider>
    </ErrorBoundary>
  </React.StrictMode>,
  document.getElementById('root'),
);
